import { render, staticRenderFns } from "./InstitucionSearch.vue?vue&type=template&id=35bb2bc5"
import script from "./InstitucionSearch.vue?vue&type=script&lang=js"
export * from "./InstitucionSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports